/* eslint-disable */
import React from 'react'
const UploadImagePlaceholder = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 46 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2876_495)">
      <path
        d="M0 46.1669C0 48.284 1.7234 50 3.83308 50H32.5218C34.6389 50 36.3548 48.2766 36.3548 46.1669V17.4782C36.3548 15.3611 34.6314 13.6451 32.5218 13.6451H3.83308C1.71597 13.6451 0 15.3685 0 17.4782V46.1669ZM32.5218 48.18H3.83308C2.72624 48.18 1.81997 47.2737 1.81997 46.1669V41.3755L8.71357 34.4819L14.6043 40.3727C14.9609 40.7293 15.5329 40.7293 15.8895 40.3727L26.527 29.7352L34.5349 37.743V46.1669C34.5349 47.2737 33.6286 48.18 32.5218 48.18ZM3.83308 15.4651H32.5218C33.6286 15.4651 34.5349 16.3714 34.5349 17.4782V35.1654L27.1658 27.8038C26.8093 27.4472 26.2373 27.4472 25.8807 27.8038L15.2432 38.4413L9.35242 32.5505C8.99585 32.194 8.42386 32.194 8.0673 32.5505L1.81997 38.7979V17.4782C1.81997 16.3714 2.72624 15.4651 3.83308 15.4651Z"
        fill="black"
      />
      <path
        d="M11.269 28.2124C13.8244 28.2124 15.897 26.1324 15.897 23.5845C15.897 21.0365 13.817 18.9565 11.269 18.9565C8.72108 18.9565 6.64111 21.0365 6.64111 23.5845C6.64111 26.1324 8.71365 28.2124 11.269 28.2124ZM11.269 20.7765C12.8216 20.7765 14.077 22.0394 14.077 23.5845C14.077 25.1296 12.8142 26.3924 11.269 26.3924C9.72392 26.3924 8.46108 25.1296 8.46108 23.5845C8.46108 22.0394 9.71649 20.7765 11.269 20.7765Z"
        fill="black"
      />
    </g>
    <rect
      x="25.2256"
      y="6.96777"
      width="17.8065"
      height="17.0645"
      fill="#F7EFE9"
    />
    <path
      d="M29.2749 14.4336V12.7705H34.3911V7.73047H36.1304V12.7705H41.2339V14.4336H36.1304V19.4736H34.3911V14.4336H29.2749Z"
      fill="black"
    />
    <defs>
      <clipPath id="clip0_2876_495">
        <rect
          width="36.3548"
          height="36.3548"
          fill="white"
          transform="translate(0 13.6451)"
        />
      </clipPath>
    </defs>
  </svg>
)

UploadImagePlaceholder.defaultProps = {
  width: 46,
  height: 50,
}

export default UploadImagePlaceholder
